import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import styles from "./MonitoringComponents.module.scss";
import { set } from "lodash";

export default function BatteryTable(props) {
  const { assetValue } = props;
  const [modal, setModal] = useState(false);

  function toggleModal() {
    setModal(!modal);
  }

  // ----- Table Data -----
  const [batteryDetails, setBatteryDetails] = useState([{}]);

  useEffect(() => {
    let varPriority = ["Non-Critical", "Critical"];
    
    const convertArrayToObjects = (array) => {
      const objects = {};
      for (const item of array) {
        objects[item.tag] = item.value;
      }

      // convert SOC to actual capacity
      objects["SOC"] = ((objects["Average SOC (%)"] / 100) * 271).toFixed(2);
      //varPriority: 0 = nothing critical,
      objects["PriorityLevel"] = varPriority[objects["varPriority"]];
      return objects;
    }

    const getTableDataWrapper = async () => {
      const response = await axios.get(
        `/batteries/getBatteryTableData?buildingId=${assetValue.value}`
      );

      if (response.status === 200) {
        setBatteryDetails(response.data.map((battery) => convertArrayToObjects(battery)));
      }
    }

    getTableDataWrapper();
  }, [assetValue]);

  let idleChargeDischarge = ["Idle", "Discharge", "Charge"];
  // ----- End of Table Data -----
  return (
    <>
      <Table className="monitoring-table table-striped table-hover">
        <thead>
          <tr>
            <th>Name</th>
            <th>State of Charge</th>
            <th>Score</th>
            <th>Idle/Charging/Discharging</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{assetValue.batteries[0]}</td>
            <td>
              {batteryDetails[0]["Average SOC (%)"]}% - {batteryDetails[0]["SOC"]}/271
              (kWh)
            </td>
            <td>{batteryDetails[0]["score"]}</td>
            <td>{idleChargeDischarge[batteryDetails[0]["CnD"]]}</td>

            <td>
              <Button color="primary" onClick={toggleModal}>
                View
              </Button>
            </td>
          </tr>
        </tbody>
      </Table>
      <Modal isOpen={modal} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Details from PYC001BAT1</ModalHeader>
        <ModalBody>
          <div>
            <div className={styles.ModalFields}>
              <strong>Priority: </strong>
              <span>{batteryDetails[0]["PriorityLevel"]}</span>
            </div>
            {/* todo -  this field is currently removed in the db */}
            {/* <div className={styles.ModalFields}>
              <strong>Days Last Serviced: </strong>
              <span>{batteryDetails[0]["dls"]}</span>
            </div> */}

            <div className={styles.ModalFields}>
              <strong>Total Alarm Count: </strong>
              <span>{batteryDetails[0]["totalCount"]}</span>
            </div>

            <div className={styles.ModalFields}>
              <strong>DLS Score: </strong>
              <span>{batteryDetails[0]["dlsScore"]}</span>
            </div>

            <div className={styles.ModalFields}>
              <strong>Alarm Error Message: </strong>
              <span>
                {batteryDetails[0]["alarmMessage"] === "{}"
                  ? "No Error"
                  : batteryDetails[0]["alarmMessage"]}
              </span>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}